import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { serviceActions } from '../../state/modules/service';
import { SecondaryButton } from '../connectedForm/Button';
import styled from 'styled-components';
import { ModalBottomButtonContainer } from './Styles';
import { Maybe } from '../../graphql/schema/p4types';
import FluentModal from './FluentModal';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const Container = styled.div`
  padding-bottom: 20px;
`;

const Logo = styled.img`
  width: 80px;
  padding-bottom: 10px;
`;

const Title = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: p4Tokens.colorNeutralForeground4;
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: p4Tokens.fieldLabel;
`;

const AboutModal = ({ isOpen, requestClose }: { isOpen: boolean; requestClose: () => void }) => {
  const dispatch = useDispatch();
  const [versionInfo, setVersionInfo] =
    useState<Maybe<{ version: string; branch: string; commit: string; timestamp: string }>>();

  //didMount
  useEffect(() => {
    (dispatch as (action: any) => Promise<any>)(
      serviceActions.genericAction('application/status', null, null, null, 'GET')
    ).then((result) => {
      setVersionInfo(result.response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!versionInfo) return null;

  return (
    <FluentModal
      isOpen={isOpen}
      onDismiss={requestClose}
      styles={{
        main: {
          position: 'absolute',
          top: '20px',
          right: '10px',
          minWidth: '320px',
          paddingBottom: '60px',
          backgroundColor: p4Tokens.colorNeutralBackground1,
        },
      }}
    >
      <div style={{ padding: '1em' }}>
        <Logo src="/images/OGL-Profit4Logo.png" alt="OGL Profit4 Logo" />
        <Container>
          <Title>Release</Title>
          <Text>{versionInfo.version}</Text>
        </Container>
        <Container>
          <Title>Build Info</Title>
          <Text>{versionInfo.branch}</Text>
          <Title>{versionInfo.commit}</Title>
          <Title>{new Date(versionInfo.timestamp).toLocaleString('en-GB')}</Title>
        </Container>
        <ModalBottomButtonContainer>
          <SecondaryButton
            onClick={(e) => {
              e.preventDefault();
              requestClose();
            }}
          >
            OK
          </SecondaryButton>
        </ModalBottomButtonContainer>
      </div>
    </FluentModal>
  );
};

export default AboutModal;

AboutModal.defaultProps = {};
